import { STATUS_STYLES } from "../lib/constants";

export function StatusBadge({ status, testid }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.draft;
  return (
    <span
      data-testid={testid || `status-badge-${status}`}
      className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border"
      style={{ color: s.text, backgroundColor: s.bg, borderColor: s.border }}
    >
      {s.label}
    </span>
  );
}

export function AwaitingBadge() {
  return (
    <span
      data-testid="awaiting-category-badge"
      className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border text-[#1B2A4A] bg-[#FDF0DC] border-[#F5961B]"
    >
      Awaiting Category
    </span>
  );
}
